import { withStyles } from '../../../utils';
import styles from './InteracWordmark.module.scss';

const cn = withStyles(styles);

export type InteracWordmarkType = 'eTransfer' | 'moneyRequest' | 'bulkPayout' | 'inbound' | 'embedded';

export type InteracWordmarkProps = {
  type?: InteracWordmarkType;
};

// Each suffix completes the customer-facing rail label from the 'Naming Cross-Check' registry
// (ID-12427), so the wordmark renders the same text the API returns in TransactionTypeLabel.
const SUFFIXES: Record<InteracWordmarkType, string> = {
  eTransfer: '',
  moneyRequest: ' Request Money',
  bulkPayout: ' Send',
  inbound: ' - Inbound',
  embedded: ' Request Money - Embedded',
};

export default function InteracWordmark({ type = 'eTransfer' }: InteracWordmarkProps) {
  // Rail labels come from API data, so `type` can arrive as an unlisted string or null,
  // which the default parameter does not cover. Fall back to the plain wordmark rather
  // than rendering `undefined` next to the trademark.
  const suffix = SUFFIXES[type] ?? SUFFIXES.eTransfer;

  return (
    <div className={cn('interacText')}>
      <i>Interac e-Transfer</i>
      <sup>®</sup>
      {suffix}
    </div>
  );
}
